import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Address } from '@flemingmetrics/api-client';
import { addCompany, setCompanies } from './companiesSlice';
import { filterBlanks } from '@/hooks/useStore/utils';

type AddressesState = {
  byId: Record<string, Address>;
};

const initialState: AddressesState = { byId: {} };

export const addressesSlice = createSlice({
  name: 'addresses',
  initialState,
  reducers: {
    addAddress: (state, action: PayloadAction<Address>) => {
      return getNextState(state, [action.payload]);
    },
    setAddresses: (state, action: PayloadAction<Address[]>) => {
      return getNextState(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setCompanies, (state, action) => {
        return getNextState(
          state,
          filterBlanks(action.payload.map((c) => c.address))
        );
      })
      .addCase(addCompany, (state, action) => {
        if (!action.payload.address) return state;
        return getNextState(state, [action.payload.address]);
      })
      .addDefaultCase((state) => state);
  },
});

function getNextState(state: AddressesState, addresses: Address[]) {
  const byId = { ...state.byId };
  addresses.forEach((address) => {
    byId[address.id] = address;
  });
  return { byId };
}

export const { addAddress, setAddresses } = addressesSlice.actions;

export default addressesSlice.reducer;
